import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserByEmail, saveCart, getCart } from '../firebase/config';
import './Pages.css';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!email || !password) {
      setError('Please fill in all fields');
      setLoading(false);
      return;
    }

    // Check user in Firebase
    const result = await getUserByEmail(email);
    setLoading(false);

    if (result.success && result.data) {
      if (result.data.password === password) {
        // Login successful
        const userData = { ...result.data };
        delete userData.password;
        const userId = userData.userId;
        
        // CHECK FOR GUEST CART - Merge with user cart
        const guestId = localStorage.getItem('guestUserId');
        let pendingCartItems = [];
        
        // Get guest cart items
        if (guestId) {
          const guestCartData = localStorage.getItem(`cart_${guestId}`);
          if (guestCartData) {
            try {
              const guestCart = JSON.parse(guestCartData);
              if (guestCart.length > 0) {
                pendingCartItems = guestCart;
              }
            } catch (e) {
              // Invalid JSON
            }
          }
        }
        
        // Also check pendingCartItems from ServicePage
        const pendingItems = localStorage.getItem('pendingCartItems');
        if (pendingItems) {
          try {
            const parsed = JSON.parse(pendingItems);
            if (parsed.length > 0) {
              // Merge with pendingCartItems
              parsed.forEach(item => {
                if (!pendingCartItems.some(i => i.id === item.id)) {
                  pendingCartItems.push(item);
                }
              });
            }
          } catch (e) {
            // Invalid JSON
          }
        }

        // Get existing user cart
        let userCart = [];
        const userCartResult = await getCart(userId);
        if (userCartResult.success && userCartResult.data) {
          userCart = userCartResult.data;
        }

        // Merge guest cart with user cart (avoid duplicates)
        if (pendingCartItems.length > 0) {
          pendingCartItems.forEach(item => {
            if (!userCart.some(i => i.id === item.id)) {
              userCart.push(item);
            }
          });
          
          // Save merged cart to Firebase
          await saveCart(userId, userCart);
          
          // Clear guest cart
          if (guestId) {
            localStorage.removeItem(`cart_${guestId}`);
          }
          localStorage.removeItem('pendingCartItems');
          localStorage.removeItem('guestUserId');
        }

        // Store user session
        localStorage.setItem('currentUser', JSON.stringify({ 
          ...userData, 
          isLoggedIn: true,
          cartMerged: pendingCartItems.length > 0
        }));

        // Show success message with cart merge info
        const mergeMessage = pendingCartItems.length > 0 
          ? `\n${pendingCartItems.length} item(s) from your guest cart have been merged with your account.`
          : '';
        alert('Login successful!' + mergeMessage);

        // Navigate to cart if there were items, otherwise home
        if (pendingCartItems.length > 0 || userCart.length > 0) {
          navigate('/cart');
        } else {
          navigate('/');
        }
      } else {
        setError('Invalid password. Please try again.');
      }
    } else {
      setError('User not found. Please register first.');
    }
  };

  return React.createElement(
    'main',
    { className: 'page-content' },
    React.createElement(
      'div',
      { className: 'container' },
      // Page Header
      React.createElement(
        'div',
        { className: 'page-header-auth' },
        React.createElement(
          'div',
          { className: 'breadcrumb-auth' },
          React.createElement(
            'a',
            { 
              href: '#',
              onClick: function(e) { e.preventDefault(); handleNavigation('/'); },
              style: { color: '#65d2bc', textDecoration: 'none', cursor: 'pointer' }
            },
            'Home'
          ),
          React.createElement('span', { className: 'separator' }, ' / '),
          React.createElement(
            'a',
            { 
              href: '#',
              onClick: function(e) { e.preventDefault(); handleNavigation('/pages'); },
              style: { color: '#65d2bc', textDecoration: 'none', cursor: 'pointer' }
            },
            'Pages'
          ),
          React.createElement('span', { className: 'separator' }, ' / '),
          React.createElement('span', { style: { color: '#0f172a', fontWeight: '600' } }, 'User Login')
        ),
        React.createElement(
          'div',
          { className: 'page-title-auth' },
          React.createElement('h1', null, 'User Login'),
          React.createElement('span', null, 'User login page')
        )
      ),

      // Login Form
      React.createElement(
        'div',
        { className: 'auth-container' },
        React.createElement(
          'div',
          { className: 'auth-card' },
          React.createElement('h2', null, 'Login'),
          error && React.createElement(
            'div',
            { className: 'error-message' },
            error
          ),
          React.createElement(
            'form',
            { onSubmit: handleLogin },
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement('label', null, 'Email Address'),
              React.createElement('input', {
                type: 'email',
                placeholder: 'Enter your email',
                value: email,
                onChange: function(e) { setEmail(e.target.value); },
                required: true,
                className: 'form-control'
              })
            ),
            React.createElement(
              'div',
              { className: 'form-group' },
              React.createElement('label', null, 'Password'),
              React.createElement('input', {
                type: 'password',
                placeholder: 'Enter your password',
                value: password,
                onChange: function(e) { setPassword(e.target.value); },
                required: true,
                className: 'form-control'
              })
            ),
            React.createElement(
              'div',
              { className: 'form-options' },
              React.createElement(
                'label',
                { className: 'checkbox-label' },
                React.createElement('input', {
                  type: 'checkbox',
                  checked: rememberMe,
                  onChange: function(e) { setRememberMe(e.target.checked); }
                }),
                ' Remember me'
              )
            ),
            React.createElement(
              'button',
              {
                type: 'submit',
                className: 'btn-primary',
                disabled: loading,
                style: { width: '100%' }
              },
              loading ? React.createElement(React.Fragment, null, React.createElement('i', { className: 'fas fa-spinner fa-spin' }), ' Logging in...') : 'Login'
            ),
            React.createElement(
              'p',
              { className: 'auth-link' },
              "Don't have an account yet? ",
              React.createElement(
                'span',
                {
                  onClick: function() { handleNavigation('/register'); },
                  style: { color: '#65d2bc', cursor: 'pointer', fontWeight: '600' }
                },
                'Register New Account'
              )
            ),
            React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn-secondary',
                onClick: function() { handleNavigation('/'); },
                style: { width: '100%', marginTop: '8px' }
              },
              React.createElement('i', { className: 'fas fa-arrow-left' }),
              ' Back to Home'
            )
          )
        )
      )
    )
  );
};

export default Login;